import { DatasetItem, SaveItemRequest } from "@rezonence/core";
import { LoadSaveHook } from "@rezonence/freewall-db-hooks";

export class RemoveNullsHook implements LoadSaveHook {
    async transform<T extends SaveItemRequest<any> | DatasetItem<any>>(input: T): Promise<T> {
        return input ? JSON.parse(JSON.stringify(input), (_, value) => value === null ? undefined : value) : input;
    }
}
